module.exports = __webpack_public_path__ + "static/79-53cdab26299fe93599742b181e7f9566.png";